import script from "./secretariatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./secretariatPage.vue?vue&type=script&setup=true&lang=js"

import "./secretariatPage.vue?vue&type=style&index=0&id=c5dc5aec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5dc5aec"]])

export default __exports__